import { TranslateService } from '@ngx-translate/core';
import { PageResponse } from '@models/page-response';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { CommonService } from '@services/common.service';
import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Group, GroupSearchingCriteria } from '@app/models/group';


@Injectable()
export class GroupService {

    constructor(
        private httpClient: HttpClient,
        private commonService: CommonService,
        private translate: TranslateService
    ) { }

    globalSearch(globalCriteria: string = '', criteria: GroupSearchingCriteria, page: number = 0, size: number = 10, sortField: string, sortDirection: string = 'asc'): Observable<PageResponse<Group>> {

        let params: HttpParams = new HttpParams();
        params = params.set('global', globalCriteria);
        params = params.set('criteria', JSON.stringify(criteria == null ? new GroupSearchingCriteria() : criteria));
        params = params.set('page', page.toString());
        params = params.set('size', size.toString());
        if (sortField != null) {
            params = params.set('sort', sortField + ',' + sortDirection);
        }

        return this.httpClient.get(`${environment.API_END_POINT}/groups`, { headers: this.commonService.getHeaders(), params: params })
            .pipe(
                map(response => {
                    let tempObj = <Group[]>(<any>response);
                    if(tempObj && tempObj.length > 0){
                        tempObj.forEach(tem =>{
                            tem.users.forEach(user=>{
                                delete user.authorities;
                                if (user.supervisor != null) {
                                    delete user.supervisor.authorities;
                                }
                            })
                        })
                    }

                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    }

    insert(group: Group): Observable<Group> {

        let body = JSON.stringify(group);

        return this.httpClient.post(`${environment.API_END_POINT}/groups`, body, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response =>  {
                    let tempObj = <Group[]>((<any>response).content);
                    if(tempObj && tempObj.length > 0){
                        tempObj.forEach(tem =>{
                            tem.users.forEach(user=>{
                                delete user.authorities;
                                if (user.supervisor != null) {
                                    delete user.supervisor.authorities;
                                }
                            })
                        })
                    }

                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );

    }

    get(id: string): Observable<Group> {
        return this.httpClient.get(`${environment.API_END_POINT}/groups/${id}`, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response =>  {
                    let tempObj = <Group[]>((<any>response).content);
                    if(tempObj && tempObj.length > 0){
                        tempObj.forEach(tem =>{
                            tem.users.forEach(user=>{
                                delete user.authorities;
                                if (user.supervisor != null) {
                                    delete user.supervisor.authorities;
                                }
                            })
                        })
                    }

                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    }

    update(group: Group): Observable<Group> {

        group.users.forEach(user =>{
            delete user.supervisor;
            delete user.authorities;
        })
        let body = JSON.stringify(group);

        return this.httpClient.put(`${environment.API_END_POINT}/groups/${group.groupId}`, body, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response =>  {
                    let tempObj = <Group[]>((<any>response).content);
                    if(tempObj && tempObj.length > 0){
                        tempObj.forEach(tem =>{
                            tem.users.forEach(user=>{
                                delete user.authorities;
                                if (user.supervisor != null) {
                                    delete user.supervisor.authorities;
                                }
                            })
                        })
                    }

                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );

    }

}